export default "__VITE_ASSET__CCcrcRH5__"